import { Link } from "react-router-dom";
import type { CSSProperties, ReactNode } from "react";

interface LegalShellProps {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}

export default function LegalShell({ title, lastUpdated, children }: LegalShellProps) {
  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh", color: "var(--ink)" }}>
      <nav
        style={{
          padding: "20px 24px",
          borderBottom: "1px solid var(--line)",
          background: "var(--surface)",
        }}
      >
        <div
          style={{
            maxWidth: 880,
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Link to="/" style={{ display: "inline-flex" }}>
            <img
              src="/logo-wordmark.png"
              alt="Troughmate"
              height={32}
              style={{ display: "block", width: "auto" }}
            />
          </Link>
          <Link
            to="/"
            style={{
              fontSize: 13,
              color: "var(--ink-3)",
              textDecoration: "none",
            }}
          >
            ← Back to site
          </Link>
        </div>
      </nav>

      <main
        style={{
          maxWidth: 720,
          margin: "0 auto",
          padding: "48px 24px 96px",
          fontSize: 15,
          lineHeight: 1.65,
        }}
      >
        <header style={{ marginBottom: 32 }}>
          <h1
            style={{
              fontSize: 32,
              fontWeight: 600,
              letterSpacing: "-0.02em",
              margin: 0,
            }}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p style={{ marginTop: 8, color: "var(--ink-3)", fontSize: 13 }}>
            Last updated: {lastUpdated}
          </p>
        </header>
        <div
          style={
            {
              // Spacing for the typographic flow inside legal docs
              "--legal-gap": "20px",
            } as CSSProperties
          }
          className="legal-body"
        >
          {children}
        </div>
      </main>

      <style>{`
        .legal-body p { margin: 0 0 var(--legal-gap, 20px); }
        .legal-body h2 {
          font-size: 18px;
          font-weight: 600;
          letter-spacing: -0.01em;
          margin: 32px 0 12px;
        }
        .legal-body ul { margin: 0 0 var(--legal-gap, 20px); padding-left: 22px; }
        .legal-body li { margin: 0 0 6px; }
        .legal-body a { color: var(--brand); }
      `}</style>
    </div>
  );
}
